module.exports = __webpack_public_path__ + "static/media/icon-payout.c5c6ff22.png";